import * as Yup from 'yup';
import Input from '../../Inputs/Input/Input';
import Button from '../../Buttons/Button/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import Form from '../../Form/Form';
import { useTypedSelector } from '../../../redux/hooks';
import { validationErrors } from '../../../utils/validators';

export interface SignInFormValues {
  email?: string;
  password?: string;
}

interface FormProps extends SignInFormValues {
  submitCallback: (values: SignInFormValues) => void;
  children?: React.ReactNode;
}

let validationSchema = Yup.object({
  email: Yup.string()
    .email(validationErrors.EMAIL)
    .required(validationErrors.REQUIRED)
    .nullable(),
  password: Yup.string()
    .required(validationErrors.REQUIRED)
    .min(8, 'Minimum 8 symbols')
    .max(50, 'Maximum 50 symbols')
    .nullable(),
});

const SignInForm: React.FC<FormProps> = ({
  children,
  submitCallback,
  ...initialFormValues
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialFormValues,
  });

  const loading = useTypedSelector(s => s.auth.loading);

  return (
    <Form loading={loading} onSubmit={handleSubmit(submitCallback)}>
      {/* ------- Email ------ */}
      <Input
        applyWorkaround
        type="email"
        inputmode="email"
        label="Email"
        autocomplete="email"
        _name="email"
        _register={register}
        _errorText={errors.email?.message}
        _setValue={setValue}
      />

      {/* ------- Password ------ */}
      <Input
        applyWorkaround
        type="password"
        inputmode="text"
        label="Password"
        autocomplete="current-password"
        _name="password"
        _register={register}
        _errorText={errors.password?.message}
        _setValue={setValue}
      />

      {/* ------- Social Providers ------- */}
      {children}

      {/* ------- Submit ------ */}
      <Button
        text="Continue"
        type="submit"
        color="secondary"
        fill="solid"
        loading={loading}
      />
    </Form>
  );
};

export default SignInForm;
